const translations = {
  "Tournaments": {
    en: "Tournaments",
    es: "Torneos",
    pt: "Torneios",
  },
  "LiveAndPastGames": {
    en: "Live And Past Games",
    es: "Partidos en Vivo y Pasados",
    pt: "Jogos ao vivo e passados",
  },
  "Videos": {
    en: "Videos",
    es: "Videos",
    pt: "Vídeos",
  },
  "NextMatches": {
    en: "Next Matches",
    es: "Próximos Partidos",
    pt: "Próximos Jogos",
  },
  "Results": {
    en: "Results",
    es: "Resultados",
    pt: "Resultados",
  },
  "Highlights": {
    en: "Highlights",
    es: "Momentos Destacados",
    pt: "Destaques",
  },
  "Matches": {
    en: "Matches",
    es: "Partidos",
    pt: "Jogos",
  },
  "No tournaments": {
    en: "No tournaments",
    es: "No hay torneos",
    pt: "Nenhum torneio",
  },
  "No tournaments are available at the moment": {
    en: "No tournaments are available at the moment",
    es: "No hay torneos disponibles en este momento",
    pt: "Nenhum torneio está disponível no momento",
  },
  "There are currently no videos available": {
    en: "There are currently no videos available",
    es: "No hay videos disponibles actualmente",
    pt: "No momento, não há vídeos disponíveis",
  },
  "There are currently no programmed events": {
    en: "There are currently no programmed events",
    es: "No hay eventos programados actualmente",
    pt: "No momento, não há eventos programados",
  },
  "No knockout ties available": {
    en: "No knockout ties available",
    es: "No hay llaves disponibles",
    pt: "Nenhum confronto disponível",
  },
  "This phase has no ties to show.": {
    en: "This phase has no ties to show.",
    es: "Esta fase no tiene llaves para mostrar.",
    pt: "Esta fase não tem confrontos para exibir.",
  },
  "To be defined": {
    en: "To be defined",
    es: "A definir",
    pt: "A definir",
  },
  "First leg": {
    en: "First leg",
    es: "Ida",
    pt: "Ida",
  },
  "Second leg": {
    en: "Second leg",
    es: "Vuelta",
    pt: "Volta",
  },
  "Aggregate": {
    en: "Aggregate",
    es: "Global",
    pt: "Agregado",
  },
  "Neutral venue": {
    en: "Neutral venue",
    es: "Estadio neutral",
    pt: "Estádio neutro",
  },
  "Postponed": {
    en: "Postponed",
    es: "Postergado",
    pt: "Adiado",
  },
  "Walkover": {
    en: "Walkover",
    es: "Por secretaría",
    pt: "Por W.O.",
  },
  "vs": {
    en: "vs",
    es: "vs",
    pt: "vs",
  },
};

export default translations;
